var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DocumentTypeEnum, DriveEventActionEnum, PrimaryDocumentTypes } from '@workalizer/shared';
var initializeActivityStats = function () { return ({
    count: 0,
    created: 0,
    edited: 0,
    viewed: 0,
    commentsUpdated: 0,
    suggestionsUpdated: 0
}); };
var documentTypesArray = Object.values(PrimaryDocumentTypes);
var createEmptyDocumentActivityResponse = function () {
    var _a;
    return (__assign(__assign({}, documentTypesArray.reduce(function (acc, type) {
        acc[type] = initializeActivityStats();
        return acc;
    }, {})), (_a = {}, _a[DocumentTypeEnum.OTHER] = initializeActivityStats(), _a)));
};
var resolveDocumentType = function (documentType) {
    return documentTypesArray.includes(documentType)
        ? documentType
        : DocumentTypeEnum.OTHER;
};
var applyDocumentActionCounts = function (result, documentType, action, count) {
    result[documentType].count += count;
    switch (action) {
        case DriveEventActionEnum.DOCUMENT_CREATE:
            result[documentType].created += count;
            break;
        case DriveEventActionEnum.DOCUMENT_EDIT:
            result[documentType].edited += count;
            break;
        case DriveEventActionEnum.DOCUMENT_VIEW:
            result[documentType].viewed += count;
            break;
        case DriveEventActionEnum.DOCUMENT_CREATE_COMMENT:
        case DriveEventActionEnum.DOCUMENT_EDIT_COMMENT:
        case DriveEventActionEnum.DOCUMENT_DELETE_COMMENT:
        case DriveEventActionEnum.DOCUMENT_RESOLVE_COMMENT:
        case DriveEventActionEnum.DOCUMENT_REOPEN_COMMENT:
            result[documentType].commentsUpdated += count;
            break;
        case DriveEventActionEnum.DOCUMENT_CREATE_SUGGESTION:
        case DriveEventActionEnum.DOCUMENT_REJECT_SUGGESTION:
        case DriveEventActionEnum.DOCUMENT_DELETE_SUGGESTION:
        case DriveEventActionEnum.DOCUMENT_ACCEPT_SUGGESTION:
            result[documentType].suggestionsUpdated += count;
            break;
    }
};
export var analyticDocumentActivityFromAggregates = function (rows) {
    var result = createEmptyDocumentActivityResponse();
    rows.forEach(function (_a) {
        var documentType = _a.documentType, action = _a.action, count = _a.count;
        applyDocumentActionCounts(result, resolveDocumentType(documentType), action, count);
    });
    return result;
};
export var analyticDocumentActivity = function (events) {
    var result = createEmptyDocumentActivityResponse();
    events.forEach(function (event) {
        applyDocumentActionCounts(result, resolveDocumentType(event.document.type), event.action, 1);
    });
    return result;
};
